/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RotateKeyForm,
  RotateKeyForm$Outbound,
  RotateKeyForm$outboundSchema,
} from "../components/rotatekeyform.js";

export type RotateAPIKeySecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type RotateAPIKeyRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  rotateKeyForm: RotateKeyForm;
};

/** @internal */
export type RotateAPIKeySecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RotateAPIKeySecurity$outboundSchema: z.ZodMiniType<
  RotateAPIKeySecurity$Outbound,
  RotateAPIKeySecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function rotateAPIKeySecurityToJSON(
  rotateAPIKeySecurity: RotateAPIKeySecurity,
): string {
  return JSON.stringify(
    RotateAPIKeySecurity$outboundSchema.parse(rotateAPIKeySecurity),
  );
}

/** @internal */
export type RotateAPIKeyRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  RotateKeyForm: RotateKeyForm$Outbound;
};

/** @internal */
export const RotateAPIKeyRequest$outboundSchema: z.ZodMiniType<
  RotateAPIKeyRequest$Outbound,
  RotateAPIKeyRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    rotateKeyForm: RotateKeyForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      rotateKeyForm: "RotateKeyForm",
    });
  }),
);

export function rotateAPIKeyRequestToJSON(
  rotateAPIKeyRequest: RotateAPIKeyRequest,
): string {
  return JSON.stringify(
    RotateAPIKeyRequest$outboundSchema.parse(rotateAPIKeyRequest),
  );
}
